import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { IContextService } from '../interfaces/context.abstract.service';
import { IOrgContextService } from '../interfaces/org-context.abstract.service';
import { DomainContext, AdvisorContextValue, PershingError, AdvisorListResponse, AdvisorListResponseObject } from '../models';
import { LogService } from './log.service';
import { ServiceRouter } from '../utils/service-router';
import { CoreConstants } from '../constants/core-constants';
import { AdvisorListServiceDefinition } from '../service-definitions/advisorlist-service-definition';
import { timeout } from 'rxjs/operators';

@Injectable()
export class OrgContextService implements IOrgContextService {
    advisorlistResponse$: Observable<AdvisorListResponse>;
    responseObject$: Observable<AdvisorListResponseObject>;
    error$: Observable<PershingError>;
    message: string[] = ['The system is unable to process your request at this time. Please try again later'];
    private _advisorlistResponse: BehaviorSubject<AdvisorListResponse>;
    private _responseObject: BehaviorSubject<AdvisorListResponseObject>;
    private _error: BehaviorSubject<PershingError>;
    domain: string;
    isOrgContextAvailable: boolean = false;
    advisorId: any = '';
    advisorName: any = '';
    roleCode: any = '';
    private baseUrl;
    // private baseUrl = 'https://netx360wealth-local-bnymellon.net:9999/Advisor.json';
     dataStore: {
        advisorlistResponse: AdvisorListResponse,
        responseObject: AdvisorListResponseObject
    };

    constructor(private logService: LogService, private http: HttpClient, private serviceRouter: ServiceRouter,
                private contextService: IContextService) {
        /* if (performance.navigation.type === 1) {  // ToDo: Need to re-visit
            console.log( 'This page is reloaded' );
            this.isOrgContextAvailable = true;
        } */
        this.logService.info('***OrgContextService constructor');
        this.dataStore = { advisorlistResponse: null, responseObject: null };
        this._advisorlistResponse = <BehaviorSubject<AdvisorListResponse>>new BehaviorSubject(null);
        this.advisorlistResponse$ = this._advisorlistResponse.asObservable();
        this._responseObject = <BehaviorSubject<AdvisorListResponseObject>>new BehaviorSubject(null);
        this.responseObject$ = this._responseObject.asObservable();
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this.contextService.selectedOrgContext$.subscribe((domainContext: DomainContext<any>) => {
            this.domain = domainContext.domain ? domainContext.domain : CoreConstants.ADVISOR;
            if (domainContext.value !== null ) {
                this.isOrgContextAvailable = true;
            }
            let contextValue = domainContext.value;
            if (contextValue instanceof AdvisorContextValue) {
                this.advisorId = contextValue.advisorId;
                this.advisorName = contextValue.advisorName;
                this.roleCode = contextValue.roleCode;
            } else {
                this.advisorId = '';
            }
        });

        // if (this.dataStore && this.dataStore.advisorlistResponse === null) {
        //     // this.loadAdvisorList();
        // } else {
        //     // let advisorId = this.OrgContextSelectionService.dataStore.advisorlistResponse.response.advisors[0].advisorId;
        //     let advisorId = this.advisorId;
        //     let advisorName = this.advisorName;
        //     let roleCode = this.roleCode;
        //     let advisorContextValue = new AdvisorContextValue(advisorId, advisorName, roleCode);
        //     this.contextService.setOrgDomainContext(this.domain, advisorContextValue);
        // }
    }

    loadAdvisorList(businessParty?: string) {
        this.logService.info('OrgContextSelectionService loadAdvisorList()');
        if (this.dataStore.responseObject) {
            this.refreshDataStore();
        }
        let queryParams = ``;
        if (businessParty) {
            this.baseUrl = this.serviceRouter.getServiceRouteURL(AdvisorListServiceDefinition.getInstance()) + '/introducing-firms/' + businessParty + '/advisors';
        } else {
            this.baseUrl = this.serviceRouter.getServiceRouteURL(AdvisorListServiceDefinition.getInstance()) + '/advisors';
        }
        this.http.get(`${this.baseUrl}` + queryParams, { responseType: 'json' })
            .pipe(timeout(20000))
            .subscribe((data: AdvisorListResponse) => {
                if (data != null) {
                    if (data.response !== null && data.response.data !== null && data.response.data.length !== 0) {
                        // this.formatData(data.response);
                        this.dataStore.advisorlistResponse = data;
                        this.dataStore.responseObject = data.response;
                        // if (!this.isOrgContextAvailable) {
                        //     let id = data.response.data[0].alternateId;
                        //     let name = data.response.data[0].fullName;
                        //     let role = data.response.data[0].role.code;
                        //     let advisorContextValue = new AdvisorContextValue(id, name, role);
                        //     this.contextService.setOrgDomainContext('advisor', advisorContextValue);
                        // }
                        // if (this.isOrgContextAvailable) {
                        //     this.isOrgContextAvailable = false;
                        // }
                        this._advisorlistResponse.next(Object.assign({}, this.dataStore).advisorlistResponse);
                        this._responseObject.next(Object.assign({}, this.dataStore).responseObject);
                        if (data['errorCode'] === 0 || data['errorCode'] === 90) { // success
                            this.logService.info('loadAdvisorList() success: ', data['errorCode']);
                            this.clearError();
                        } else { // error code from backend
                            this.logService.error('loadAdvisorList() errorCode: ', data['errorCode']);
                            this.setError(this.message[0], data['errorCode']);
                        }
                    } else {
                        this.logService.error('loadHouseholdList() errorCode: ', data['errorCode']);
                        this.setError(this.message[0], data['errorCode']);
                    }
                }
            },
            error => { // exception
                this.logService.error('loadAdvisorList() exception:', error);
                this.setError(this.message[0], error._body);
                // throw error;
            });
            // this.dataStore.selectedFilterValue = null;
    }

    private refreshDataStore(): void {
        this.dataStore.responseObject = null;
        this._responseObject.next(Object.assign({}, this.dataStore).responseObject);
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'Org Context Service', errorCode));
    }

    clearError(): void {
        this._error.next(null);
    }
}
